export enum CATEGORY {
  WAREHOUSE_FAR = "/warehouse-far",
  WAREHOUSE_NON_FAR = "/warehouse-non-far",
  DSD_NON_FRESH = "/dsd-non-fresh",
}
